import axios from './http'

/**
 * 验证token
 * @returns {Promise<AxiosResponse<any>>}
 */
function checkToken() {
  return axios.get('/v1/u/check/token')
}

/**
 * 刷新token
 * @param refreshToken
 * @returns {Promise<AxiosResponse<any>>}
 */
function refreshToken(refreshToken) {
  return axios.get('/v1/u/refresh_token', {params:{refresh_token:refreshToken}})
}

/**
 * 登录
 * @param username
 * @param password
 * @param code
 * @param formKey
 * @returns {Promise<AxiosResponse<any>>}
 */
function login(username, password, code, formKey) {
  return axios.post('/v1/u/login', {
    username: username,
    password: password,
    code: code,
    form_key: formKey,
  })
}

/**
 * 验证码手机号码是否存在
 * @param phone
 * @returns {Promise<AxiosResponse<any>>}
 */
function phoneExist(phone) {
  return axios.get('/v1/u/check/phone', {params: {phone}})
}

/**
 *
 * @param phone
 * @param password
 * @param code
 * @param form_key
 * @returns {Promise<AxiosResponse<any>>}
 */
function register(phone, password, code, form_key) {
  return axios.post('/v1/u/register', {phone, password, code, form_key})
}

/**
 * 使用token获取用户信息
 * @returns {Promise<AxiosResponse<any>>}
 */
function getUserInfo() {
  return axios.get('/v1/u/userinfo')
}

/**
 * 获取已认证的信息
 * @returns {Promise<AxiosResponse<any>>}
 */
function getAuthFinishInfo() {
  return axios.get('/v1/u/auth/finish')
}

/**
 * 获取安全码
 * @param formKey
 * @param code
 * @returns {Promise<AxiosResponse<any>>}
 */
function safetycode(formKey, code, phone) {
  return axios.post('/v1/u/safety_code/phone', {
      form_key: formKey,
      code: code,
	  phone: phone,
  })
}

/**
 * 修改密码
 * @param safety
 * @param old_password
 * @param password
 * @returns {Promise<AxiosResponse<any>>}
 */
function updatepassword(safety, old_password, password) {
  return axios.post('/v1/u/password', {
      safety: safety,
      old_password: old_password,
	  password: password,
  })
}

/**
 * 邮箱绑定
 * @param safety
 * @param email
 * @param code
 * @returns {Promise<AxiosResponse<any>>}
 */
function bindEmail(safety, email, code) {
  return axios.post('/v1/u/bind/email', {
      safety: safety,
      email: email,
	  code: code,
  })
}

/**
 * 找回密码
 * @param safety
 * @param password
 * @returns {Promise<AxiosResponse<any>>}
 */
function findPassword(safety, password) {
  return axios.post('/v1/u/find/password', {
      safety: safety,
      password: password,
  })
}

/**
 * 用户头像上传
 * @param profile
 * @returns {Promise<AxiosResponse<any>>}
 */
function profile(profile) {
  return axios.post('/v1/u/user/profile', {profile},{
	  headers: {'Content-Type': 'multipart/form-data'}
  })
}

/**
 * logo上传
 * @param logo
 * @returns {Promise<AxiosResponse<any>>}
 */
function entLogo(logo) {
  return axios.post('/v1/u/ent/logo', {logo},{
	  headers: {'Content-Type': 'multipart/form-data'}
  })
}

/**
 * 用户信息修改
 * @param region_code
 * @param addr
 * @param tel
 * @param fax
 * @param industry
 * @param industry_info
 * @param scale
 * @param intro
 * @param website
 * @returns {Promise<AxiosResponse<any>>}
 */
function modifyuserinfo(region_code, addr, tel, fax, industry, industry_info, scale, intro, website) {
  return axios.put('/v1/u/userinfo', {
      region_code: region_code,
      addr: addr,
	  tel: tel,
	  fax: fax,
	  industry: industry,
	  industry_info: industry_info,
	  scale: scale,
	  intro: intro,
	  website: website,
  })
}

/**
 * 删除logo
 * @returns {Promise<AxiosResponse<any>>}
 */
function dellogo() {
  return axios.delete('/v1/u/ent/logo')
}

/**
 * 保密资源上传
 * @param file
 * @param type
 * @returns {Promise<AxiosResponse<any>>}
 */
function resPrivate(file, type, path) {
  return axios.post('/v1/u/resource/private', {
	  file: file,
	  type: type,
	  path: path,
  },{
	  headers: {'Content-Type': 'multipart/form-data'}
  })
}

/**
 * 企业认证
 * @param name
 * @param code
 * @param auth_type
 * @param photo1
 * @param photo2
 * @param user_name
 * @param user_id_card
 * @param user_photo1
 * @param user_photo2
 * @param type
 * @returns {Promise<AxiosResponse<any>>}
 */
function authEnt(name, code, auth_type, photo1, photo2, user_name, user_id_card, user_photo1, user_photo2, type) {
  return axios.post('/v1/u/auth/ent', {
      name: name,
      code: code,
	  auth_type: auth_type,
	  photo1: photo1,
	  photo2: photo2,
	  user_name: user_name,
	  user_id_card: user_id_card,
	  user_photo1: user_photo1,
	  user_photo2: user_photo2,
	  type: type,
  })
}

/**
 * 企业认证
 * @param name
 * @param id_card
 * @param photo1
 * @param photo2
 * @param phone
 * @param bank_card
 * @param type
 * @returns {Promise<AxiosResponse<any>>}
 */
function authUser(name, id_card, photo1, photo2, phone, bank_card, type) {
  return axios.post('/v1/u/auth/user', {
      name: name,
      id_card: id_card,
	  photo1: photo1,
	  photo2: photo2,
	  phone: phone,
	  bank_card: bank_card,
	  type: type,
  })
}

/**
 * 获取认证状态
 * @returns {Promise<AxiosResponse<any>>}
 */
function getAuthAudit() {
  return axios.get('/v1/u/auth/audit')
}

/**
 * 获取用户认证信息
 * @returns {Promise<AxiosResponse<any>>}
 */
function getAuthInfo() {
  return axios.get('/v1/u/auth/info')
}

/**
 * 退出登录
 * @returns {Promise<AxiosResponse<any>>}
 */
function logout() {
  return axios.post('/v1/u/logout', {
  })
  location.reload()
}

/**
 * 认证资源管理
 * @param id
 * @returns {Promise<AxiosResponse<any>>}
 */
function getResource(id) {
  return axios.get('/v1/u/resource/private', {params: {id} })
}

export default {
  login,
  phoneExist,
  register,
  checkToken,
  refreshToken,
  getUserInfo,
  getAuthFinishInfo,
  safetycode,
  updatepassword,
  bindEmail,
  findPassword,
  profile,
  entLogo,
  modifyuserinfo,
  dellogo,
  resPrivate,
  authEnt,
  authUser,
  getAuthAudit,
  getAuthInfo,
  logout,
  getResource
}
